module.exports = __webpack_public_path__ + "media/images/search-icon-db8f13ebdad46b9f66bec97b3519fd15.svg";